import Header from "@/components/header";
import React, {useEffect, useState} from 'react'
import {useSelector} from "react-redux";
import {RootState} from "@/types/store";
import Footer from "@/components/Footer";
import {getSafeHttpUrl} from '@/utils/common'

const Backurl = () => {
    const [list] = useSelector(
        (state: RootState) => [state.app.config.backup_site_url]
    )
    const [speedList, SetSpeedList] = useState<any[]>([])
    useEffect(() => {
        let arr:Array<any>=[]
        list.forEach((item,index)=>{
            arr[index]=(Math.random() * 40 + 20).toFixed(0)+'ms'
        })
        SetSpeedList(arr)
    }, [list])
    return (
        <div className="arrdv9-0 kaxIlA">
            <Header></Header>
                <div className="yield">
                    <div className="back-wrap">
                        <h3>备用网址</h3>
                        <p className="subtitle">截图保存
                        </p>
                        <div className="back-list">
                            <ul>
                                {
                                    list.map((item:any,index)=>{
                                        const safeUrl = getSafeHttpUrl(item)
                                        return( <li key={index} className="list-item">
                                            <div className="url-left">
                                                {item}
                                            </div>
                                            <div className="test-time">
                                                {speedList[index]}
                                            </div>
                                            <div className="entry">
                                                {safeUrl ? (
                                                    <a target="_blank" rel="noopener noreferrer" href={safeUrl}>进入</a>
                                                ) : (
                                                    <span>无效地址</span>
                                                )}
                                            </div>
                                        </li>)
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            <Footer></Footer>
        </div>
    )
}

export default Backurl
